import { memo } from 'react';

function CloudCircleIcon({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M8.40693 13.5927L10.9997 11M13.5924 8.40728L10.9997 11M10.9997 11L8.40693 8.40728M10.9997 11L13.5924 13.5927"
        stroke="#637381"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 20.1663C16.0626 20.1663 20.1666 16.0623 20.1666 10.9997C20.1666 5.93706 16.0626 1.83301 11 1.83301C5.93737 1.83301 1.83331 5.93706 1.83331 10.9997C1.83331 16.0623 5.93737 20.1663 11 20.1663Z"
        stroke="#637381"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default memo(CloudCircleIcon);
